import axios from 'axios'
import React, { useEffect, useState } from 'react'
import authService from '../../../Components/Login/auth.service'

export default function Modal({ setOpenModal, modalInfo }) {
  var user = authService.getCurrentUser()
  const [gerencias, setGerencia] = useState([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/gerencia/list/' +
        user[0].IdEmpresa
      )
      .then(response => {
        setGerencia(response.data)
      })
  }, [])

  let newDate = new Date()
  const [campos, setCampos] = useState({
    IdLocalArea: modalInfo.IdLocalArea,
    IdEmpresa: modalInfo.IdEmpresa,
    IdUnidade: modalInfo.IdUnidade,
    IdGerencia: modalInfo.IdGerencia,
    locDescricao: modalInfo.locDescricao,
    locReferencia: modalInfo.locReferencia,
    locStatus: modalInfo.locStatus,
    locObservacoes: modalInfo.locObservacoes,
    locAlteradoPor: user[0].pesEmail,
    locAlteradoEm: newDate
  })
  function handleInputChange(event) {
    if (event.target.name === 'locStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
    //console.log(campos)
  }
  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .put(
        process.env.REACT_APP_API_URL + '/api/v1/area/' + campos.IdLocalArea,
        campos
      )
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }
  return (
    <div className="modalArea">
      <div
        onClick={() => {
          setOpenModal(false)
        }}
        className="overlay"
      ></div>
      <div className="modalPadrao-content">
        <div className="cxTituloPadrao">
          <h1>
            Editar Local
            <hr className="hrTitleModal" />
          </h1>
          <button
            onClick={() => {
              setOpenModal(false)
            }}
          >
            X
          </button>
        </div>

        <form onSubmit={handleFormSubmit}>
          <label>Novo Local:</label>
          <input
            placeholder="Nome Local"
            type="text"
            id="fname"
            defaultValue={campos.locDescricao}
            name="locDescricao"
            onChange={handleInputChange}
          ></input>

          <label>Referência:</label>
          <input
            placeholder="Referência"
            type="text"
            id="fname"
            defaultValue={campos.locReferencia}
            name="locReferencia"
            onChange={handleInputChange}
          ></input>

          <label>Observações:</label>
          <textarea
            placeholder="Observações"
            type="text"
            id="fname"
            name="locObservacoes"
            defaultValue={campos.locObservacoes}
            row="none"
            onChange={handleInputChange}
            maxLength="500"
          ></textarea>

          <div className="caixaSalvarPadrao">
            <div className="InputAuthorization4">
              <label>
                <input
                  name="locStatus"
                  type="checkbox"
                  defaultChecked={!!campos.locStatus}
                  onChange={handleInputChange}
                />
                <span>Status</span>
              </label>
            </div>

            <button type="submit">Salvar Registro</button>
          </div>
        </form>
      </div>
    </div>
  )
}
